module.exports = __webpack_public_path__ + "static/media/contacto.dd8b7463.png";